import type { DocMigration } from "../docMigration";

function renameCastComponentsTable(json: any): void {
  if (json.cipComponents !== undefined && json.cipComponents !== null && typeof json.cipComponents === "object") {
    // Already migrated or created under the new name.
    if (json.castComponents !== undefined) {
      delete json.castComponents;
    }
    return;
  }

  const castComponents = json.castComponents;
  if (
    castComponents === undefined ||
    castComponents === null ||
    typeof castComponents !== "object" ||
    Array.isArray(castComponents)
  ) {
    json.cipComponents = {};
    delete json.castComponents;
    return;
  }

  const cipComponents: Record<string, unknown> = {};
  for (const componentId of Object.keys(castComponents)) {
    const component = castComponents[componentId];
    if (component === undefined || component === null || typeof component !== "object") {
      continue;
    }

    const componentRecord = { ...(component as Record<string, unknown>) };
    const castType = componentRecord.castType;
    delete componentRecord.castType;
    delete componentRecord.entityType;

    cipComponents[componentId] = {
      ...componentRecord,
      entityType: "CIP_COMPONENT",
      cipType: castType ?? "CONCRETE",
    };
  }

  json.cipComponents = cipComponents;
  delete json.castComponents;
}

function renameCastComponentIdsOnWallPlaneAssemblies(json: any): void {
  const assemblies = json.wallPlaneAssemblies;
  if (assemblies === undefined || assemblies === null || typeof assemblies !== "object") {
    return;
  }

  for (const assemblyId of Object.keys(assemblies)) {
    const assembly = assemblies[assemblyId];
    if (assembly === undefined || assembly === null || typeof assembly !== "object") {
      continue;
    }
    const layers = assembly.layers;
    if (layers === undefined || layers === null || typeof layers !== "object") {
      continue;
    }

    for (const layerId of Object.keys(layers)) {
      const layer = layers[layerId];
      if (layer === undefined || layer === null || typeof layer !== "object") {
        continue;
      }
      if (layer.layerType !== "CAST_IN_PLACE" && layer.layerType !== "CAST") {
        continue;
      }
      if (layer.castComponentId === undefined) {
        continue;
      }
      layer.cipComponentId = layer.castComponentId;
      delete layer.castComponentId;
      if (layer.layerType === "CAST") {
        layer.layerType = "CAST_IN_PLACE";
      }
    }
  }
}

const migration: DocMigration = {
  id: "20260804_rename_cast_components_to_cip",
  description:
    "Renames castComponents → cipComponents, CAST_COMPONENT → CIP_COMPONENT, castType → cipType, and castComponentId → cipComponentId",
  apply(json: any, _warnings: string[], _errors: string[]): any {
    renameCastComponentsTable(json);
    renameCastComponentIdsOnWallPlaneAssemblies(json);
    return json;
  },
};

export default migration;
